import {
    FETCH_SAWI_SPECIAL,
    FETCH_SAWI_SPECIAL_SUCCESS,
    FETCH_SAWI_SPECIAL_FAILED,
    SAVE_SAWI_SPECIAL,
    SAVE_SAWI_SPECIAL_SUCCESS,
    SAVE_SAWI_SPECIAL_FAILED,
} from '../actions/sawiSpecialActions';

const initialState = { loading: false, data: null, error: null };

export const sawiSpecialReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SAWI_SPECIAL:
        case SAVE_SAWI_SPECIAL:
            return { ...state, loading: true, error: null };
        case FETCH_SAWI_SPECIAL_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case SAVE_SAWI_SPECIAL_SUCCESS:
            return { ...state, loading: false };
        case FETCH_SAWI_SPECIAL_FAILED:
        case SAVE_SAWI_SPECIAL_FAILED:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
